<template>
    <article>
        <p>
            Coroot allows you to organize your applications into custom groups called Application Categories.
            These act like scopes, helping you either hide certain applications or focus on specific ones more easily.
        </p>

        <p>
            To configure Application Categories, go to the project settings (<v-icon small>mdi-cog</v-icon>),
            click on Applications, and adjust the built-in categories or create your own custom ones.
            Each category is defined by a set of <a href="https://en.wikipedia.org/wiki/Glob_(programming)" target="_blank">glob patterns</a>
            in the <var>&lt;namespace&gt;/&lt;application_name&gt;</var> format.
        </p>

        <p>
            Coroot also includes several pre-defined categories, such as <var>monitoring</var> and <var>control-plane</var>.
        </p>

        <v-card max-width="1200">
            <v-img eager src="/static/img/docs/coroot/categories.png" />
        </v-card>

        <h2>Quick links</h2>

        <p>
            To make organizing your apps easier, Coroot allows you to define the category for an app directly on the service map:
        </p>

        <v-card max-width="1200">
            <v-img eager src="/static/img/docs/coroot/category_service_map.png" />
        </v-card>

        <p>... or application page:</p>

        <v-card max-width="1200">
            <v-img eager src="/static/img/docs/coroot/category_app_page.png" />
        </v-card>

    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
</style>
